/*
 * @Author: your name
 * @Date: 2020-12-24 14:59:45
 * @LastEditTime: 2021-03-22 11:45:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\assets\js\AdminMember\adminGraph.js
 */
import echarts from 'echarts'
import {
  findMemberTypeNum,
  findIndustryStatistic,
  findPractitionerEducation,
  findPractitionerYear,
  findPractitionerTechnical,
  findMechanismStatistic,
  findIndustryGrowth,
  findIndustryRanking,
  findBusinessIncome,
  findIncomeStatistic,
  findCompanyNumber,
  findPractitionerNumber,
  exportExcel,
  findSurveyYearList
} from '@/api/index'
let reg = new RegExp('%', 'g')
let option = [
  {
    value: 1,
    label: '信用调查与服务'
  },
  {
    value: 2,
    label: '公共信用管理服务'
  },
  {
    value: 3,
    label: '信用评价'
  },
  {
    value: 4,
    label: '信用担保'
  },
  {
    value: 5,
    label: '保理'
  },
  {
    value: 6,
    label: '信用保险服务'
  },
  {
    value: 7,
    label: '商账管理服务'
  },
  {
    value: 8,
    label: '大数据信用信息服务'
  },
  {
    value: 9,
    label: '信用管理咨询'
  }
]
export default {
  data() {
    return {
      yearValue: '',
      // 查询会员类型数量
      memberTypeData: [],
      numAll: 0,
      //echartsOne
      businessType: '',
      typeOptions: option,
      echartsDomOne: null,
      echartsDomTwo: null,
      echartsDomThree: null,
      echartsDomFour: null,
      echartsDomFive: null,
      echartsDomSix: null,
      echartsDomSeven: null,
      echartsDomEight: null,
      echartsDomNine: null,
      echartsDomTen: null,
      echartsOneData: [],
      echartsOneYearData: [],
      oneBarData: [],
      oneLineData: [],
      //echartsTwo
      echartsTwoData: [],
      echartsTwoYearData: [],
      twoLine1Data: [],
      twoLine2Data: [],
      twoLine3Data: [],
      //echartsThree
      echartsThreeData: [],
      echartsThreeYearData: [],
      threeBarData: [],
      threeLine1Data: [],
      threeLine2Data: [],
      // echartsFour
      fourParams: {
        year: '',
        businessType: ''
      },
      echartsFourData: [],
      fourLegendData: [],
      fourBarData: [],
      // echartsFive
      fiveParams: {
        year: '',
        incomeType: 1
      },
      processOptions: [
        {
          value: 1,
          label: '一年增长率'
        },
        {
          value: 2,
          label: '三年增长率'
        },
        {
          value: 3,
          label: '五年增长率'
        }
      ],
      echartsFiveData: [],
      fiveLegendData: [],
      fiveBarData: [],
      fiveLineData: [],
      fiveIndexNumber: 0,
      // echartsSix
      yearSixValue: '',
      echartsSixData: [],
      // echartsSeven
      echartsSevenData: [],
      echartsSevenYearData: [],
      sevenBarData: [],
      sevenLine1Data: [],
      sevenLine2Data: [],
      sevenLine3Data: [],
      // echartsEight
      echartsEightData: [{ name: '', value: '' }],
      eightLegendData: [],
      // echartsNine
      echartsNineData: [{ name: '', value: '' }],
      nineLegendData: [],
      // echartsTen
      echartsTenData: [{ name: '', value: '' }],
      tenLegendData: [],
      // echartsEleven
      echartsElevenBarData: [],
      echartsElevenLineData: [],
      echatrsElevenYearList: [],
      elevenBarData: [],
      elevenLineData: [],

      yearOptions: [],
      tableParams: {
        year: '',
        operationType: '',
        businessType: ''
      },
      incomeOptions: [
        {
          value: 1,
          label: '1000万以上'
        },
        {
          value: 2,
          label: '500万-1000万'
        },
        {
          value: 3,
          label: '200万-500万'
        },
        {
          value: 4,
          label: '200万以下'
        }
      ],
      excelParams: [],
      isDrag: false,
      fixedX: 0,
      fixedY: 0,
      echartsDoms: [],
      maxUsePage: 10,
      tableOneData: [], // 当前页的数据，用于给表格展示用的
      tableOneDataAll: [], // 需要拿来分页的总数据
      pagination: {
        totalRows: 0, //总条数
        pageSize: 10, //每页显示条数
        pageNumber: 1
      }
    }
  },
  created() {
    // if(this.yearOptions == null || this.yearOptions ==''){
    this.yearCommon()

    // }

    this.getMemberTypeNum()
  },
  mounted() {
    window.addEventListener('resize', this.chartResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.chartResize)
  },
  methods: {
    // 跳转会员管理页面
    toAdminManage(type) {
      // 如果是在导出页面，就不跳转
      if (this.$route.name == 'exportAdminGraph') {
        return
      } else {
        this.$router.push({
          name: `AdminManagement`,
          params: {
            adminGraphType: type
          }
        })
      }
    },
    //查询所有数据
    async yearCommon() {
      try {
        const { data } = await findSurveyYearList()
        if (data.code != 0) return
        var questionData = JSON.parse(JSON.stringify(data.questionnaireManagementList))
        this.yearOptions = questionData.map(item => {
          return item.year
        })
        this.yearOptions.sort(function (a, b) {
          return b - a
        })

        this.tableParams.year = this.yearOptions ? this.yearOptions[0] : ''
        this.fourParams.year = this.yearOptions ? this.yearOptions[0] : ''
        this.fiveParams.year = this.yearOptions ? this.yearOptions[0] : ''
        this.yearSixValue = this.yearOptions ? this.yearOptions[0] : ''

        this.getEchartsOneData()
        this.getEchartsTwoData()
        this.getEchartsThreeData()
        this.getTableOneData()
        this.getEchartsFourData()
        this.getEchartsFiveData()
        this.getEchartsSixData()
        this.getEchartsSevenData()
        this.getEchartsEightData()
        this.getEchartsNineData()
        this.getEchartsTenData()
      } catch { }
    },
    chartResize() {
      let eleArr = [
        this.echartsDomOne,
        this.echartsDomTwo,
        this.echartsDomThree,
        this.echartsDomFour,
        this.echartsDomFive,
        this.echartsDomSix,
        this.echartsDomSeven,
        this.echartsDomEight,
        this.echartsDomNine,
        this.echartsDomTen
      ]
      for (let i = 0; i < eleArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          eleArr[i].resize()
        }, 200)
      }
    },
    mousedown(e) {
      //鼠标左键点击
      this.isDrag = true
      this.fixedX = e.pageX - this.$refs.export.offsetLeft
      this.fixedY = e.pageY - this.$refs.export.offsetTop
      e.preventDefault()
    },
    mousemove(e) {
      if (this.isDrag) {
        this.$refs.export.style.left = e.pageX - this.fixedX + 'px'
        this.$refs.export.style.top = e.pageY - this.fixedY + 'px'
      }
    },
    mouseup(e) {
      this.isDrag = false
    },
    //双击 导出html
    exportHtml() {
      //跳转新页面
      let { href } = this.$router.resolve('/adminGraph')
      window.open(href, '_blank')
    },
    // 导出营业收入机构排名
    async exportsExcel() {
      try {
        // businessType: ""
        // operationType: ""
        // year: "2018"
        let arrData = JSON.parse(JSON.stringify(this.tableOneDataAll))
        // 如果是在导出HTML页面，不显示且不导 出营业收入
        if (this.$route.name == 'exportAdminGraph') {
          arrData.forEach((item, index) => {
            this.excelParams.push({
              companyName: item.companyName
            })
          })
        } else {
          arrData.forEach((item, index) => {
            this.excelParams.push({
              companyName: item.companyName,
              operatingIncome: item.operatingIncome
            })
          })
        }

        var paramsToexcel = {
          businessType: this.tableParams.businessType,
          operationType: this.tableParams.operationType,
          year: this.tableParams.year,
          industryRankDtoList: this.excelParams
        }
        const { data } = await exportExcel(paramsToexcel)
        const link = document.createElement('a')
        let blob = new Blob([data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)

        link.download = this.tableParams.year + '年营业收入机构排名' //下载的文件名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        // console.log(error);
        // this.$message.error(error.data.msg)
        const link = document.createElement('a')
        let blob = new Blob([error.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)

        link.download = this.tableParams.year + '年营业收入机构排名' //下载的文件名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    // 查询会员类型数量
    async getMemberTypeNum() {
      const { data } = await findMemberTypeNum()
      if (data.code != 0) return
      this.memberTypeData = JSON.parse(JSON.stringify(data.memberTypeNumDtoList))

      this.memberTypeData.forEach((item, index) => {
        this.numAll += item.memberNum
      })
    },
    // 机构数统计
    async getEchartsOneData() {
      const { data } = await findMechanismStatistic(this.businessType)
      if (data.code == 0) {
        this.echartsOneData = JSON.parse(JSON.stringify(data.statisticalDtoList))
        this.echartsOneData.sort(function (a, b) {
          return a.year - b.year
        })
        // console.log("echartsOneData", this.echartsOneData);
        this.echartsOneData.forEach((item, index) => {
          this.echartsOneYearData.push(item.year)
          this.oneBarData.push(item.number)
        })
      }

      // 这个红色的折现，67/102,71/113,79/129,101/131
      // 67/1123,71/1283,79/1263,86/1360,102/1322
      // this.echartsOneYearData = [2020,2021]
      // this.oneBarData = [1,1]
      if (this.businessType == '') {
        this.oneLineData = [6, 6, 6, 6, 8]
      } else {
        this.oneLineData = []
      }
      this.$nextTick(() => {
        this.echartsOne()
      })
    },
    oneEchartChange() {
      this.echartsOneYearData = []
      this.oneBarData = []
      this.oneLineData = []
      this.getEchartsOneData()
    },
    // 信用行业协会收入增长比较
    async getEchartsTwoData() {
      // const { data } = await findIndustryGrowth()
      // if (data.code == 0) {
      // this.echartsTwoData = JSON.parse(JSON.stringify(data.industryGrowthDtoList))
      // this.echartsTwoData.forEach(item => {
      // this.echartsTwoYearData.push(item.year)
      // this.twoLine1Data.push(parseInt(item.industryRate.replace(reg, '')))
      // this.twoLine2Data.push(parseInt(item.shanghaiGdpRate.replace(reg, '')))
      // this.twoLine3Data.push(parseInt(item.chinaGdpRate.replace(reg, '')))
      // })

      // }
      this.echartsTwoYearData = [2018, 2019, 2020, 2021]
      // 2017总数4271469.08, 平均值97078.84,
      // 2018总数1776821.06, 平均值41321.42,
      // 2019年总和2365529.41,
      // 2020总数2792808.81, 平均53707.86173,
      // 2021年总和3056220.24,

      // 协会:(2021年-2020年)/2020年
      // this.twoLine1Data = [-52, 15, 29.2]; //协会
      this.twoLine1Data = [-52, 15, 18.06, 9.43] //协会
      // this.twoLine2Data = [8.7, 8.2, 11.8]; //上海
      this.twoLine2Data = [20.55, 8.64, 2, 11.86] //上海
      // this.twoLine3Data = [7.98, 7.2, 10]; //全国
      this.twoLine3Data = [11.71, 9.33, 3.1, 10.45] //全国
      this.$nextTick(() => {
        this.echartsTwo()
      })
    },
    // 信用行业机构收入统计
    async getEchartsThreeData() {
      // const { data } = await findIndustryStatistic()
      // if (data.code == 0) {
      // this.echartsThreeData = JSON.parse(JSON.stringify(data.industryDtoList))
      // this.echartsThreeData.forEach(item => {
      // this.echartsThreeYearData.push(item.year)
      // this.threeBarData.push(item.industryAverage / 10)
      // this.threeLine1Data.push(item.industryHighWorth / 10)
      // this.threeLine2Data.push(item.industryLowWorth / 10)
      // })
      // }
      this.echartsThreeYearData = [2017, 2018, 2019, 2020, 2021]
      this.threeBarData = [97078, 41321, 49286, 56996, 62089] //平均
      this.threeLine1Data = [2631791, 308200, 356681, 759419, 818613] //高位
      this.threeLine2Data = [8270, 8000, 8411, 8003, 9138] //中位
      this.$nextTick(() => {
        this.echartsThree()
      })
    },
    // 营业收入机构排名 table1
    async getTableOneData() {
      const { data } = await findIndustryRanking(this.tableParams)
      if (data.code == 0) {
        this.tableOneDataAll = JSON.parse(JSON.stringify(data.industryRankDtoList))

        this.$nextTick(function () {
          // 初始化渲染
          this.pagination.pageNumber = 1
          // 得到总数据tableOneDataAll进行分页
          this.dataPagination(this.tableOneDataAll)
        })
      }
      echartsFour
    },
    // 4信用行业机构收入统计
    async getEchartsFourData() {
      const { data } = await findBusinessIncome(this.fourParams)
      if (data.code == 0) {
        this.echartsFourData = JSON.parse(JSON.stringify(data.industryRankDtoList))
        this.echartsFourData.forEach(item => {
          if (item.operationType == 1) {
            item.operationType = '10000万以上'
          } else if (item.operationType == 2) {
            item.operationType = '1000万-10000万'
          } else if (item.operationType == 3) {
            item.operationType = '100万-1000万'
          } else if (item.operationType == 4) {
            item.operationType = '100万以下'
          }
          this.fourLegendData.unshift(item.operationType)
          this.fourBarData.push(item.companyNumber)
        })
      }
      // this.fourLegendData = ['100万以下 ' ,'100万-1000万','  1000万-10000万','  10000万以上 ']
      // this.fourBarData = [1,0,3,3]
      this.$nextTick(() => {
        this.echartsFour()
      })
    },
    fourEchartChange() {
      this.fourLegendData = []
      this.fourBarData = []
      this.getEchartsFourData()
    },
    // 5各年份业务收入及其增长率统计
    async getEchartsFiveData() {
      const { data } = await findIncomeStatistic(this.fiveParams)
      if (data.code == 0) {
        this.echartsFiveData = JSON.parse(JSON.stringify(data.incomeStatisticalDtoList))
        this.echartsFiveData.forEach(item => {
          this.fiveLegendData.push(item.businessType)
          this.fiveBarData.push(item.operationIncome)
          this.fiveLineData.push(parseInt(item.growthRate.replace(reg, '')))
        })
      }

      // this.fiveLegendData = ['信用调查','公共信用','信用评价','信用担保','保理','信用保险','商账管理']
      // this.fiveBarData = [12,14,5,1,9,45,35]
      // this.fiveLineData = [15,20,60,30,80,20,10]
      this.$nextTick(() => {
        this.echartsFive()
      })
    },
    fiveEchartChange() {
      this.fiveLegendData = []
      this.fiveBarData = []
      this.fiveLineData = []
      this.getEchartsFiveData()
    },
    // 6机构人数统计
    async getEchartsSixData() {
      this.echartsSixData = []
      try {
        const { data } = await findCompanyNumber(this.yearSixValue)
        if (data.code == 0) {
          var dataAll = JSON.parse(JSON.stringify(data.companyNumberList))
          // if(dataAll.length == 0){
          //   this.echartsSixData.push([0,0])
          // }else{
          dataAll.forEach(item => {
            if (item.avgIncomePerson == 657947.82 && item.totalIncome == 2631791.26) {
            } else {
              this.echartsSixData.push([item.totalIncome, item.avgIncomePerson])
            }
          })
          // }
        }
        this.$nextTick(() => {
          this.echartsSix()
        })
      } catch (error) {
        this.$message.error(error.data.msg)
      }
    },
    // 机构年份切换
    sixEchartsChange() {
      this.getEchartsSixData()
      this.getEchartsEightData()
      this.getEchartsNineData()
      this.getEchartsTenData()
    },
    // 7从业人员数量统计
    async getEchartsSevenData() {
      const { data } = await findPractitionerNumber()
      if (data.code == 0) {
        this.echartsSevenData = JSON.parse(JSON.stringify(data.industryNumberDtoList))
        this.echartsSevenData.forEach(item => {
          this.echartsSevenData.sort(function (a, b) {
            return a.year - b.year
          })

          this.echartsSevenYearData.push(item.year)

          this.sevenBarData.push(Math.round(item.personAverage)) //平均值
          this.sevenLine1Data.push(item.personHighWorth) //高位
          // if (item.year == "2017") {
          //   this.sevenLine1Data.push(630);
          // } else {
          //   this.sevenLine1Data.push(item.personHighWorth);
          // }
          this.sevenLine2Data.push(item.personCenterWorth) //中位
          // if (item.year == "2018") {
          //   this.sevenLine3Data.push(2);
          // } else {
          //   this.sevenLine3Data.push(item.personLowWorth);
          // }
          this.sevenLine3Data.push(item.personLowWorth) //低位
        })
        // this.sevenBarData = [60, 73, 59];
        // this.sevenLine2Data = [32, 28, 25];
      }
      this.$nextTick(() => {
        this.echartsSeven()
      })
    },
    // 从业人员学历构成情况
    async getEchartsEightData() {
      try {
        const { data } = await findPractitionerEducation(this.yearSixValue)
        if (data.code == 0) {
          this.echartsEightData = JSON.parse(JSON.stringify(data.practitionerDtoList))
          if (this.echartsEightData.length == 0) {
            this.eightLegendData.push('无')
            this.echartsEightData.push({
              name: '无',
              value: 0
            })
          } else {
            this.echartsEightData.forEach((item, index) => {
              this.eightLegendData.push(item.typeName)
              item.name = item.typeName
              item.value = item.typeRate
              if (item.name == '高中及以下学历') {
                item.value = this.yearSixValue == '2019' ? 215 : this.yearSixValue == '2018' ? 407 : item.typeRate
              }
            })
          }
        }
        this.$nextTick(() => {
          this.echartsEight()
        })
      } catch (error) {
        // console.log(error);
      }
    },
    // 从业人员从业年限构成情况
    async getEchartsNineData() {
      try {
        const { data } = await findPractitionerYear(this.yearSixValue)
        if (data.code == 0) {
          this.echartsNineData = JSON.parse(JSON.stringify(data.practitionerDtoList))
          if (this.echartsNineData.length == 0) {
            this.nineLegendData.push('无')
            this.echartsNineData.push({
              name: '无',
              value: 0
            })
          } else {
            this.echartsNineData.forEach((item, index) => {
              this.nineLegendData.push(item.typeName)
              item.name = item.typeName
              item.value = item.typeRate
              if (item.name == '一年以下') {
                item.value = this.yearSixValue == '2019' ? 479 : this.yearSixValue == '2018' ? 650 : item.typeRate
              }
            })
          }
        }
        this.$nextTick(() => {
          this.echartsNine()
        })
      } catch (error) {
        // console.log(error);
      }
    },
    // 从业人员专业技术职称构成情况
    async getEchartsTenData() {
      try {
        const { data } = await findPractitionerTechnical(this.yearSixValue)
        if (data.code == 0) {
          this.echartsTenData = JSON.parse(JSON.stringify(data.practitionerDtoList))
          if (this.echartsTenData.length == 0) {
            this.tenLegendData.push('无')
            this.echartsTenData.push({
              name: '无',
              value: 0
            })
          } else {
            this.echartsTenData.forEach((item, index) => {
              this.tenLegendData.push(item.typeName)
              item.name = item.typeName
              item.value = item.typeRate
              if (item.name == '无技术职称人数') {
                item.value = this.yearSixValue == '2019' ? 3241 : this.yearSixValue == '2018' ? 3147 : item.typeRate
              }
            })
          }
          this.$nextTick(() => {
            this.echartsTen()
          })
        }
      } catch (error) {
        // console.log(error);
      }
    },

    echartsOne() {
      this.echartsDomOne = this.$echarts.init(document.querySelector('#echartsOne'))
      let option = {
        color: ['#ff8f78', '#36a4ff'],
        grid: {
          top: '18%',
          left: '12%',
          right: '12%'
        },
        legend: {
          itemGap: this.$route.name == 'exportAdminGraph' ? 20 : 50,
          data: ['协会会员数', '协会会员占上海信用服务机构的比例']
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            crossStyle: {
              color: '#999'
            }
          },
          formatter: params => {
            // 自定义tooltip提示内容
            var tip = ''
            params.forEach((item, index) => {
              if (index == 0) {
                item.marker =
                  '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#36a4ff;"></span>'
                tip = tip + params[0].name + '<br />' + params[0].marker + params[0].seriesName + '：' + params[0].value + '<br />'
              } else if (index == 1) {
                tip = tip + params[1].marker + params[1].seriesName + '：' + params[1].value + '%<br />'
              }
            })
            return tip
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.echartsOneYearData,
            axisLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '机构数/家',
            min: 0, //一定要设置最小刻度
            max: 105, //一定要设置最大刻度
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter: function (value, index) {
                //Y轴的自定义刻对应上图
                var str = ''
                if (String(value).indexOf('.') == -1) {
                  str = value
                } else {
                  str = ''
                }
                return str
              }
            }
          },
          {
            type: 'value',
            name: '比例值/%',
            axisLine: {
              show: false
            },
            min: 0, //一定要设置最小刻度
            max: 100, //一定要设置最大刻度
            // minInterval: 20, //这个可自己设置刻度间隔
            axisLabel: {
              formatter: function (value, index) {
                //Y轴的自定义刻对应上图
                if (index == 0) {
                  value = 0
                } else if (index == 1) {
                  value = 20 + '%'
                } else if (index == 2) {
                  value = 40 + '%'
                } else if (index == 3) {
                  value = 60 + '%'
                } else if (index == 4) {
                  value = 80 + '%'
                } else if (index == 5) {
                  value = 100 + '%'
                }
                return value
              }
            }
          }
        ],
        series: [
          {
            name: '协会会员数',
            animation: false,
            type: 'bar',
            barWidth: '15',
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#36a4ff' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#0a64c0' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                barBorderRadius: [30, 30, 30, 30]
              }
            },
            data: this.oneBarData
          },
          {
            name: '协会会员占上海信用服务机构的比例',
            animation: false,
            type: 'line',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#ff8f78'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3 //设置线条粗细
                }
              }
            },
            data: this.oneLineData
          }
        ]
      }
      this.echartsDomOne.setOption(option, true)
    },
    echartsTwo() {
      this.echartsDomTwo = this.$echarts.init(document.querySelector('#echartsTwo'))
      let option = {
        color: ['#1f82de', '#7963cd', '#ff8f78'],
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: params => {
            // 自定义tooltip提示内容
            var tip = ''
            params.forEach((item, index) => {
              if (index == 0) {
                tip = tip + params[0].name + '<br />'
              }
              tip += params[index].marker + params[index].seriesName + '：' + params[index].value + '%<br />'
            })
            return tip
          }
        },
        legend: {
          itemGap: 10,
          data: ['信用协会行业增长度', '上海第三产业GDP统计', '全国第三产业GDP统计']
        },
        grid: {
          left: '5%',
          right: '5%',
          top: '23%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: false
            },
            // boundaryGap: false,
            data: this.echartsTwoYearData
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '增长率/%',
            // min: 0,  //一定要设置最小刻度
            // max: 0.2,  //一定要设置最大刻度
            minInterval: 0.1, //这个可自己设置刻度间隔
            axisLine: {
              show: false
            },
            axisLabel: {
              // formatter: function (value, index) {  //Y轴的自定义刻度值，对应上图
              //   if (index == 0) {
              //     value = 0
              //   } else if (index == 1) {
              //     value = 0.1 + '%'
              //   } else if (index == 2) {
              //     value = 0.2 + '%'
              //   } else if (index == 3) {
              //     value = 60 + '%'
              //   } else if (index == 4) {
              //     value = 80 + '%'
              //   } else if (index == 5) {
              //     value = 100 + '%'
              //   }
              //   return value
              // }
            }
          }
        ],
        series: [
          {
            name: '信用协会行业增长度',
            type: 'line',
            // stack: '增长率',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#1f82de'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3 //设置线条粗细
                }
              }
            },
            data: this.twoLine1Data
          },
          {
            name: '上海第三产业GDP统计',
            type: 'line',
            // stack: '增长率',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#7963cd'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3 //设置线条粗细
                }
              }
            },
            data: this.twoLine2Data
          },
          {
            name: '全国第三产业GDP统计',
            type: 'line',
            // stack: '增长率',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#ff8f78'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3 //设置线条粗细
                }
              }
            },
            data: this.twoLine3Data
          }
        ]
      }
      this.echartsDomTwo.setOption(option, true)
    },
    echartsThree() {
      this.echartsDomThree = this.$echarts.init(document.querySelector('#echartsThree'))
      let option = {
        color: ['#7963CD', '#ff8f78', '#248ae5'],
        title: {
          text: '机构收入/千',
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          top: '18%',
          left: '20%',
          right: '13%',
          bottom: '12%'
        },
        legend: {
          data: ['高位', '平均值', '中位']
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            crossStyle: {
              color: '#999'
            }
          },
          formatter: params => {
            // 自定义tooltip提示内容
            var tip = ''
            params.forEach((item, index) => {
              if (index == 0) {
                tip = "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#248ae5'></span>" + params[index].seriesName + '：'
                // if (params[index].value == 300000) {
                //   tip += 263179;
                // } else if (params[index].value == 200000) {
                //   tip += 30820;
                // } else if (params[index].value == 255000) {
                //   tip += 35668;
                // } else {
                // tip += params[index].value;
                // }
                if (index == 0) {
                  tip += this.threeLine1Data[params[index].dataIndex]
                }
                tip += '<br />'
              } else {
                tip += params[index].marker + params[index].seriesName + '：' + params[index].value + '<br />'
              }
            })
            return tip
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: false
            },
            data: this.echartsThreeYearData
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '高位',
            min: 0, //一定要设置最小刻度
            max: 10000000, //一定要设置最大刻度
            splitNumber: 4,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true
            },
            axisLabel: {
              formatter: function (value, index) {
                // console.log("value", value);
                //Y轴的自定义刻对应上图

                if (value >= 10000000) {
                  return '10,000,000\n及以上'
                } else if (value == 9000000) {
                  return '800,000'
                } else if (value == 6000000) {
                  return '100,000'
                } else if (value == 3000000) {
                  return '20,000'
                } else {
                  // return "0";
                }
                return value
              }
            }
          },
          {
            type: 'value',
            axisLine: {
              show: false
            },
            min: 0,
            max: 100000, //一定要设置最大刻度
            name: '平均值/中位',
            // splitNumber: 5 ,
            minInterval: 4000,
            maxInterval: 20000
          }
        ],
        series: [
          {
            name: '高位',
            type: 'bar',
            // barMinHeight: "20000",
            // smooth: true,
            barWidth: '15',
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                  [
                    {
                      offset: 0,
                      color: '#36a4ff' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#0a64c0' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                barBorderRadius: [30, 30, 30, 30]
              }
            },
            data: this.threeLine1Data.map(value => {
              let v1 = value
              // console.log("value", value);
              // this.threeLine1Data = [2631791, 308200, 356681, 759419, 818613]; //高位
              // 刻度20,000_柱高3,000,000，
              // 刻度100,000_柱高6,000,000，
              // 刻度800,000_柱高9,000,000,
              // 刻度10,000,000_柱高10,000,000,
              // 真实数据对应的柱高 = 柱子下高度+（真实数据-下刻度）*（柱子上高度-下高度/（上刻度-下刻度））
              if (value >= 10000000) {
                v1 = value
              } else if (value >= 800000) {
                v1 = 9000000 + (value - 800000) * (1000000 / (10000000 - 800000))
              } else if (value >= 100000) {
                v1 = 6000000 + (value - 100000) * (3000000 / (800000 - 100000))
              } else if (value >= 20000) {
                v1 = 3000000 + (value - 20000) * (3000000 / (100000 - 20000))
              } else if (value > 0) {
                v1 = value * (3000000 / 20000)
              } else {
                v1 = value
              }
              // console.log("v1", v1);
              return v1
            })

            // data: this.threeLine1Data
          },
          {
            name: '平均值',
            type: 'line',
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#7963CD'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3, //设置线条粗细
                  color: '#7963CD'
                }
              }
            },
            data: this.threeBarData
          },
          {
            name: '中位',
            type: 'line',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#ff8f78'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3 //设置线条粗细
                }
              }
            },
            data: this.threeLine2Data
          }
        ]
      }
      this.echartsDomThree.setOption(option, true)
    },
    echartsFour() {
      this.echartsDomFour = this.$echarts.init(document.querySelector('#echartsFour'))
      const CubeLeft = this.$echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint
          const c0 = [shape.x, shape.y]
          const c1 = [shape.x - 10, shape.y - 10]
          const c2 = [xAxisPoint[0] - 10, xAxisPoint[1] - 10]
          const c3 = [xAxisPoint[0], xAxisPoint[1]]
          ctx.moveTo(c0[0], c0[1])
            .lineTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .closePath()
        }
      })
      const CubeRight = this.$echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint
          const c1 = [shape.x, shape.y]
          const c2 = [xAxisPoint[0], xAxisPoint[1]]
          const c3 = [xAxisPoint[0] + 20, xAxisPoint[1] - 10]
          const c4 = [shape.x + 20, shape.y - 10]
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath()
        }
      })
      const CubeTop = this.$echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y]
          const c2 = [shape.x + 20, shape.y - 10]
          const c3 = [shape.x + 10, shape.y - 20]
          const c4 = [shape.x - 10, shape.y - 10]
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath()
        }
      })
      this.$echarts.graphic.registerShape('CubeLeft', CubeLeft)
      this.$echarts.graphic.registerShape('CubeRight', CubeRight)
      this.$echarts.graphic.registerShape('CubeTop', CubeTop)
      // const MAX = [200, 500, 1000, 10000]
      const MAX = this.fourBarData
      // const VALUE = [2012, 1230, 3790, 2349]
      let option = {
        backgroundColor: '#fff',
        title: {
          text: '',
          top: 32,
          left: 18,
          textStyle: {
            color: '#00F6FF',
            fontSize: 24
          }
        },
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {
          //   type: 'cross',
          //   label: {
          //     backgroundColor: '#6a7985'
          //   }
          // },
          confine: true,
          formatter: params => {
            // 自定义tooltip提示内容
            var tip = ''
            params.marker = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#36a4ff;"></span>'
            if (params.dataIndex == 0) {
              tip = params.marker + params.name + '：' + this.fourBarData[0] + '个<br />'
            } else if (params.dataIndex == 1) {
              tip = params.marker + params.name + '：' + this.fourBarData[1] + '个<br />'
            } else if (params.dataIndex == 2) {
              tip = params.marker + params.name + '：' + this.fourBarData[2] + '个<br />'
            } else if (params.dataIndex == 3) {
              tip = params.marker + params.name + '：' + this.fourBarData[3] + '个<br />'
            }
            return tip
          }
        },
        grid: {
          left: 20,
          right: 40,
          bottom: '25%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: '收入',
          data: this.fourLegendData,
          axisLine: {
            show: false
            // lineStyle: {
            //     color: 'white'
            // }
          },
          offset: 20
          // axisTick: {
          //     show: false,
          //     length: 9,
          //     alignWithLabel: true,
          //     lineStyle: {
          //         color: '#7DFFFD'
          //     }
          // },
          // axisLabel: {
          //     fontSize: 10
          // }
        },
        yAxis: {
          type: 'value',
          name: '机构数',
          min: 0, //一定要设置最小刻度
          // max: 10,  //一定要设置最大刻度
          axisLine: {
            show: false
            // lineStyle: {
            //     color: 'white'
            // }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          }
          // axisLabel: {
          //     fontSize: 16
          // },
          // boundaryGap: ['40%', '50%']
        },
        series: [
          {
            type: 'custom',
            renderItem: function (params, api) {
              const location = api.coord([api.value(0), api.value(1)])
              return {
                type: 'group',
                children: [
                  {
                    type: 'CubeLeft',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: 'rgba(31,130,222,.6)'
                    }
                  },
                  {
                    type: 'CubeRight',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: 'rgba(31,130,222,.4)'
                    }
                  },
                  {
                    type: 'CubeTop',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: 'rgba(31,130,222,.6)'
                    }
                  }
                ]
              }
            },
            data: MAX
          },
          {
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)])
              return {
                type: 'group',
                children: [
                  {
                    type: 'CubeLeft',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: '#3B80E2'
                        },
                        {
                          offset: 1,
                          color: '#49BEE5'
                        }
                      ])
                    }
                  },
                  {
                    type: 'CubeRight',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: '#3B80E2'
                        },
                        {
                          offset: 1,
                          color: '#49BEE5'
                        }
                      ])
                    }
                  },
                  {
                    type: 'CubeTop',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0])
                    },
                    style: {
                      fill: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: '#3B80E2'
                        },
                        {
                          offset: 1,
                          color: '#49BEE5'
                        }
                      ])
                    }
                  }
                ]
              }
            },
            data: this.fourBarData
          },
          {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 16,
                color: '#000',
                offset: [4, -20]
              }
            },
            itemStyle: {
              color: 'transparent'
            }
            // data: MAX
          }
        ]
      }
      this.echartsDomFour.setOption(option, true)
    },
    echartsFive() {
      let a = ''
      if (this.fiveParams.incomeType == 1) {
        a = '一年增长率'
      } else if (this.fiveParams.incomeType == 2) {
        a = '三年增长率'
      } else if (this.fiveParams.incomeType == 3) {
        a = '五年增长率'
      } else if (this.fiveParams.incomeType == '') {
        a = '年增长率'
      }
      this.echartsDomFive = this.$echarts.init(document.querySelector('#echartsFive'))
      let option = {
        color: ['#ff8f78', '#3dbce0'],
        grid: {
          top: '15%',
          left: '10%',
          right: '10%',
          bottom: '25%'
        },
        legend: {
          data: ['业务收入', `${a}`]
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            crossStyle: {
              color: '#999'
            }
          },
          formatter: params => {
            // 自定义tooltip提示内容
            var tip = ''
            params.forEach((item, index) => {
              if (index == 0) {
                item.marker =
                  '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#36a4ff;"></span>'
                tip = tip + params[0].name + '<br />' + params[0].marker + params[0].seriesName + '：' + params[0].value + '<br />'
              } else if (index == 1) {
                tip = tip + params[1].marker + params[1].seriesName + '：' + this.fiveLineData[params[index].dataIndex] + '%<br />'
              }
            })
            return tip
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              formatter: function (value) {
                if (value.length > 4) {
                  return value.slice(0, 4) + '...'
                } else {
                  return value
                }
              }
            },
            data: this.fiveLegendData
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '营业收入总额（千元）',
            axisLine: {
              show: false
            }
            // min: 0,  //一定要设置最小刻度
          },
          {
            type: 'value',
            name: `${a}`,
            splitNumber: 5,
            axisLine: {
              show: false
            },
            // min: 0,  //一定要设置最小刻度
            // max: 8000, //一定要设置最大刻度
            axisLabel: {
              formatter: function (value, index) {
                // this.fiveIndexNumber =
                // console.log("fiveIndexNumber", fiveIndexNumber);
                // Y轴的自定义刻对应上图;
                // console.log(index);
                if (index == 0) {
                  value = -100
                } else if (index == 1) {
                  value = 0
                }
                return value + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '业务收入',
            type: 'bar',
            barWidth: '15',
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#36a4ff' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#0a64c0' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                barBorderRadius: [30, 30, 30, 30]
              }
            },
            data: this.fiveBarData
          },
          {
            name: `${a}`,
            type: 'line',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#ff8f78'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 3 //设置线条粗细
                }
              }
            },
            data: this.fiveLineData.map(value => {
              let v1 = value
              // console.log("valuevaluevalue", value);
              // this.threeLine1Data = [2631791, 308200, 356681, 759419, 818613]; //高位
              // 刻度-100，柱高-10000，

              // 真实数据对应的柱高 = 柱子下高度+（真实数据-下刻度）*（柱子上高度-下高度/（上刻度-下刻度））
              if (a == '一年增长率') {
                if (value < 0 && value > -10000) {
                  v1 = 0 + value * (-10000 / -100)
                } else {
                  v1 = value
                }
              } else if (a == '三年增长率') {
                if (value < 0 && value > -1000) {
                  v1 = 0 + value * (-1000 / -100)
                } else {
                  v1 = value
                }
              } else if (a == '五年增长率') {
                if (value < 0 && value > -2000) {
                  v1 = 0 + value * (-2000 / -100)
                } else {
                  v1 = value
                }
              }
              // console.log("valuevalue", v1);
              return v1
            })
          }
        ]
      }
      this.echartsDomFive.setOption(option, true)
    },
    echartsSix() {
      this.echartsDomSix = this.$echarts.init(document.querySelector('#echartsSix'))
      let option = {
        // title: {
        //   text: 'Dispersion of house price based on the area',
        //   left: 'center',
        //   top: 0
        // },
        // visualMap: {
        //   min: 10,
        //   max: 1000,
        //   dimension: 1,
        //   orient: 'vertical',
        //   right: 10,
        //   top: 'center',
        //   text: ['HIGH', 'LOW'],
        //   calculable: true,
        //   inRange: {
        //     color: ['#f2c31a', '#24b7f2']
        //   }
        // },
        grid: {
          left: `${this.echartsSixData.length == 0 ? '7.5%' : '2%'}`,
          right: '18%',
          top: '12%',
          bottom: '6%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          // axisPointer: {
          //   type: 'cross'
          // },
          formatter: params => {
            // 自定义tooltip提示内容
            var str = '营业收入总额' + '：' + params.value[0] + '<br>' + '人均年产值' + '：' + params.value[1]
            return str
          }
        },

        xAxis: [
          {
            type: 'value',
            name: '营业收入总额/千元',
            axisLine: {
              show: false
            },
            min: 0,
            // max: 10000,
            splitLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '人均年产值/千元',
            axisLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '营业收入总额/人均年产值',
            type: 'scatter',
            symbolSize: 10,
            itemStyle: {
              normal: {
                color: '#248ae5',
                borderWidth: 0.9,
                borderColor: '#248ae5',
                backgroundColor: '#fff',
                opacity: 0.2
              }
            },
            data: this.echartsSixData
          }
        ]
      }
      this.echartsDomSix.setOption(option, true)
    },
    echartsSeven() {
      this.echartsDomSeven = this.$echarts.init(document.querySelector('#echartsSeven'))
      let option = {
        // color: ['#36a4ff', '#ff8f78', '#248ae5', '#7567d0'],
        title: {
          text: '从业人员数/人',
          textStyle: {
            fontSize: 12
          },
          left: 45,
          top: 4
        },
        grid: {
          top: '25%',
          left: '12%',
          right: '8%',
          bottom: '7%'
        },
        legend: {
          data: ['高位', '平均值', '中位', '低位']
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              show: false
            },
            data: this.echartsSevenYearData
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '高位',
            axisLine: {
              show: false
            },
            min: 0, //一定要设置最小刻度
            max: 750, //一定要设置最大刻度
            minInterval: 150,
            maxInterval: 150
          },
          {
            axisLine: {
              show: false
            },
            name: '平均值/中位/低位',
            type: 'value',
            min: 0, //一定要设置最小刻度
            max: 500, //一定要设置最大刻度
            minInterval: 50,
            maxInterval: 100
          }
        ],
        series: [
          {
            name: '高位',
            type: 'bar',
            barWidth: '15',
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: '#36a4ff' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#0a64c0' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                barBorderRadius: [30, 30, 30, 30]
              }
            },

            data: this.sevenLine1Data
          },
          {
            name: '平均值',
            type: 'line',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#ff8f78'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#ff8f78',
                lineStyle: {
                  width: 3, //设置线条粗细
                  color: '#ff8f78'
                }
              }
            },
            data: this.sevenBarData
          },

          {
            name: '中位',
            type: 'line',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#91CB74'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#91CB74',
                lineStyle: {
                  width: 3, //设置线条粗细
                  color: '#91CB74'
                }
              }
            },
            data: this.sevenLine2Data
          },
          {
            name: '低位',
            type: 'line',
            smooth: true,
            areaStyle: {
              // 折线图背景渐变
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#7567d0'
                },
                {
                  offset: 1,
                  color: '#fff'
                }
              ])
            },
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: '#7567d0',
                lineStyle: {
                  width: 3, //设置线条粗细
                  color: '#7567d0'
                }
              }
            },
            data: this.sevenLine3Data
          }
        ]
      }
      this.echartsDomSeven.setOption(option, true)
    },
    // 从业人员学历构成情况
    echartsEight() {
      let that = this
      this.echartsDomEight = this.$echarts.init(document.querySelector('#echartsEight'))
      let option = {
        color: this.echartsEightData[0].name == '无' ? ['#ccc'] : ['#FF8F78', '#7963CD', '#3DBCE0', '#CBB64D'],
        title: {
          text: '总数',
          subtext: `${this.yearSixValue == '2019' ? 3470 : this.yearSixValue == '2018' ? 3390 : eval(this.echartsEightData.map(u => { return u.value }).join('+'))}`, //副标题：企业数量值，此处用标题方式来显示
          x: '27%',
          y: '34%',
          textAlign: 'center',
          zlevel: -1,
          textStyle: {
            color: '#abafb3',
            fontSize: '14',
            fontWeight: 500
          },
          subtextStyle: {
            color: '#000',
            fontSize: '16',
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          // formatter: '{a} <br/>{b}: {c} ({d}%)'
          formatter: '{b}: {c}'
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: '25%',
          icon: 'circle',
          textStyle: {
            fontSize: 13,
            width: 160,
            rich: {
              a: {
                align: 'left',
                color: '#abafb3',
                padding: [0, 0, 0, 0]
              }
            }
          },
          formatter: function (name) {
            let _index = 0
            that.echartsEightData.forEach((item, i) => {
              if (item.name == name) {
                _index = i
              }
            })
            let arr = [name, '{a|' + that.echartsEightData[_index].value + '}']

            return arr.join(' ')
          },
          data: this.eightLegendData
        },
        series: [
          {
            name: '',
            zlevel: 22,
            type: 'pie',
            radius: ['50%', '60%'],
            center: this.echartsEightData[0].name == '无' ? ['42%', '42%'] : ['28%', '42%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16'
              }
            },
            labelLine: {
              show: false
            },
            data: this.echartsEightData
          }
        ]
      }
      this.echartsDomEight.setOption(option, true)
      this.echartsDomEight.on('mouseover', params => {
        this.echartsDomEight.setOption({
          title: {
            show: false //当鼠标移动上是，则设置 title 不显示
          }
        })
      })

      this.echartsDomEight.on('mouseout', params => {
        this.echartsDomEight.setOption({
          title: {
            show: true //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
      this.echartsDomEight.on('highlight', function (params) {
        that.echartsDomEight.setOption({
          title: {
            show: false //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
      this.echartsDomEight.on('downplay', function (params) {
        that.echartsDomEight.setOption({
          title: {
            show: true //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
    },
    // 从业人员从业年限构成情况
    echartsNine() {
      let that = this
      this.echartsDomNine = this.$echarts.init(document.querySelector('#echartsNine'))
      let option = {
        color: this.echartsNineData[0].name == '无' ? ['#ccc'] : ['#FF8F78', '#7963CD', '#3DBCE0', '#CBB64D'],
        title: {
          text: '总数',
          subtext: `${this.yearSixValue == '2019'
            ? 3470
            : this.yearSixValue == '2018'
              ? 3390
              : eval(
                this.echartsNineData
                  .map(u => {
                    return u.value
                  })
                  .join('+')
              )
            }`, //副标题：企业数量值，此处用标题方式来显示
          x: '32%',
          y: '34%',
          textAlign: 'center',
          textStyle: {
            color: '#abafb3',
            fontSize: '14',
            fontWeight: 500
          },
          subtextStyle: {
            color: '#000',
            fontSize: '16',
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          // formatter: '{a} <br/>{b}: {c} ({d}%)'
          formatter: '{b}: {c}'
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: '25%',
          icon: 'circle',
          textStyle: {
            fontSize: 13,
            width: 160,
            rich: {
              a: {
                align: 'left',
                color: '#abafb3',
                // padding: [0, 0, 0, 10],
                padding: [0, 0, 0, 0]
              }
            }
          },
          formatter: function (name) {
            let _index = 0
            that.echartsNineData.forEach((item, i) => {
              if (item.name == name) {
                _index = i
              }
            })
            let arr = [name, '{a|' + that.echartsNineData[_index].value + '}']
            return arr.join(' ')
          },
          data: this.nineLegendData
        },
        series: [
          {
            name: '',
            type: 'pie',
            // radius: ['50%', '65%'],
            radius: ['50%', '60%'],
            center: this.echartsNineData[0].name == '无' ? ['48%', '42%'] : ['33%', '42%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16'
                // fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.echartsNineData
          }
        ]
      }
      this.echartsDomNine.setOption(option, true)
      this.echartsDomNine.on('mouseover', params => {
        this.echartsDomNine.setOption({
          title: {
            show: false //当鼠标移动上是，则设置 title 不显示
          }
        })
      })

      this.echartsDomNine.on('mouseout', params => {
        this.echartsDomNine.setOption({
          title: {
            show: true //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
      this.echartsDomNine.on('highlight', function (params) {
        that.echartsDomNine.setOption({
          title: {
            show: false //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
      this.echartsDomNine.on('downplay', function (params) {
        that.echartsDomNine.setOption({
          title: {
            show: true //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
    },
    // 从业人员专业技术职称构成情况
    echartsTen() {
      let that = this
      this.echartsDomTen = this.$echarts.init(document.querySelector('#echartsTen'))
      let option = {
        color: this.echartsTenData[0].name == '无' ? ['#ccc'] : ['#FF8F78', '#7963CD', '#3DBCE0', '#CBB64D'],
        title: {
          text: '总数', subtext: `${this.yearSixValue == '2019' ? 3470 : this.yearSixValue == '2018' ? 3390 : eval(
            this.echartsTenData.map(u => {
              return u.value
            }).join('+')
          )}`, //副标题：企业数量值，此处用标题方式来显示
          x: '34%',
          y: '34%',
          textAlign: 'center',
          textStyle: {
            color: '#abafb3',
            fontSize: '14',
            fontWeight: 500
          },
          subtextStyle: {
            color: '#000',
            fontSize: '16',
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          // formatter: '{a} <br/>{b}: {c} ({d}%)'
          formatter: '{b}: {c}'
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: '25%',
          icon: 'circle',
          textStyle: {
            fontSize: 13,
            width: 160,
            rich: {
              a: {
                align: 'left',
                color: '#abafb3',
                // padding: [0, 0, 0, 10],
                padding: [0, 0, 0, 0]
              }
            }
          },
          formatter: function (name) {
            let _index = 0
            that.echartsTenData.forEach((item, i) => {
              if (item.name == name) {
                _index = i
              }
            })
            let arr = [name, '{a|' + that.echartsTenData[_index].value + '}']
            return arr.join(' ')
          },
          data: this.tenLegendData
        },
        series: [
          {
            name: '',
            type: 'pie',
            // radius: ['50%', '65%'],
            radius: ['50%', '60%'],
            center: this.echartsTenData[0].name == '无' ? ['55%', '42%'] : ['35%', '42%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16'
                // fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.echartsTenData
          }
        ]
      }
      this.echartsDomTen.setOption(option, true)
      this.echartsDomTen.on('mouseover', params => {
        this.echartsDomTen.setOption({
          title: {
            show: false //当鼠标移动上是，则设置 title 不显示
          }
        })
      })

      this.echartsDomTen.on('mouseout', params => {
        this.echartsDomTen.setOption({
          title: {
            show: true //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
      this.echartsDomTen.on('highlight', function (params) {
        that.echartsDomTen.setOption({
          title: {
            show: false //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
      this.echartsDomTen.on('downplay', function (params) {
        that.echartsDomTen.setOption({
          title: {
            show: true //当鼠标移动上是，则设置 title 不显示
          }
        })
      })
    },
    // 自定义分页
    currentChange(val) {
      //页码改变
      this.pagination.pageNumber = val
      this.dataPagination(this.tableOneDataAll)
    },
    sizeChange(val) {
      //切换每页显示条数
      this.pagination.pageSize = val
      this.dataPagination(this.tableOneDataAll)
    },
    dataPagination(dataList) {
      // debugger
      if (!dataList || dataList.length <= 0) {
        dataList = []
        this.tableOneData = []
      }
      let pageNo = this.pagination.pageNumber
      let pageSize = this.pagination.pageSize
      var offset = (pageNo - 1) * pageSize
      this.pagination.totalRows = dataList.length
      this.tableOneData = offset + pageSize >= dataList.length ? dataList.slice(offset, dataList.length) : dataList.slice(offset, offset + pageSize)
    }
  }
}
